import { create } from "zustand";

interface SidebarStoreProps {
  isSidebarOpen: boolean;
  handleOpenSidebar: () => void;
  closeSidebar: () => void;
  boxProfileOpen: boolean;
  toggleBoxProfile: () => void;
  closeBoxProfile: () => void;
}

export const useSidebarStore = create<SidebarStoreProps>((set) => ({
  isSidebarOpen: false,
  boxProfileOpen: false,

  handleOpenSidebar: () =>
    set((state) => ({
      isSidebarOpen: !state.isSidebarOpen,
      boxProfileOpen: false,
    })),

  closeSidebar: () => set({ isSidebarOpen: false }),

  toggleBoxProfile: () =>
    set((state) => ({
      boxProfileOpen: !state.boxProfileOpen,
      isSidebarOpen: false,
    })),

  closeBoxProfile: () => set({ boxProfileOpen: false }),
}));
